<div fxLayout="column">
    <h2 fxFlex="0 0 auto" mat-dialog-title class="center-align">Switch Profiles</h2>
    <mat-dialog-content fxFlex="auto" class="center-align">
        <mat-radio-group class="radio-group" [(ngModel)]="selectedProfileKey">
            <mat-radio-button color="primary" class="radio-button" *ngFor="let profile of profiles" [value]="profile.objectValue">{{profile.displayValue}}</mat-radio-button>
        </mat-radio-group>
    </mat-dialog-content>
    <div fxFlexFill>
        <span> </span>
    </div>

    <mat-dialog-actions fxFlex="0 0 auto" align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button color="primary" [disabled]="!selectedProfileKey" (click)="switchProfile()" [mat-dialog-close]="switchResult">Apply</button>
    </mat-dialog-actions>
</div>